// extracted by mini-css-extract-plugin
export default {"plugWrapper":"TokenPlug_plugWrapper__uKixE","title":"TokenPlug_title__lq1l8","text":"TokenPlug_text__qSTbc"};